/**
 * Migas de pan.
 *
 * El ultimo eslabon es la pagina actual: va sin enlace y con `aria-current`,
 * porque un enlace a la pagina en la que ya estas no lleva a ninguna parte.
 * La version en datos estructurados (`BreadcrumbList`) se arma desde la misma
 * lista, en `seo/esquemas.ts`.
 */
import { Link } from 'react-router-dom';

import type { Miga } from '../../seo/esquemas';
import { Icono } from '../comunes/Icono';

export interface MigasProps {
  /** De la raiz a la pagina actual, incluida. */
  migas: Miga[];
}

export function Migas({ migas }: MigasProps) {
  return (
    <nav className="miga" aria-label="Migas de pan">
      <ol>
        {migas.map((miga, indice) => {
          const ultima = indice === migas.length - 1;
          return (
            <li key={miga.nombre}>
              {indice > 0 ? <Icono nombre="chevron" /> : null}
              {ultima || miga.ruta === undefined ? (
                <span aria-current="page">{miga.nombre}</span>
              ) : (
                <Link to={miga.ruta}>{miga.nombre}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
